import ApiClient from '@/plugins/AxiosPlugin'

export default {
    namespaced: true,
    actions: {
        updatePONumber: updatePONumber
    }
}

function updatePONumber(context, payload) {
    return new Promise((resolve, reject) => {
        const url = context.rootState.settings.update_po_number;
        let formData = new FormData();
        formData.append('hasPurchaseOrderNumberUpdated', payload["hasPurchaseOrderNumberUpdated"]);
        formData.append('purchaseOrderNumberValue', payload["purchaseOrderNumberValue"]);
        formData.append('sapLineItemNumbers', JSON.stringify(payload["sapLineItemNumbers"]));

        return ApiClient.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch(function(error) {
            reject(error);
        });
    });
}